import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { MenuHeaderComponent } from '@shared/components/menu-header/menu-header.component';
import { MenuAsideComponent } from '@shared/components/menu-aside/menu-aside.component';
import pt from '@angular/common/locales/pt';
import { AcessoNaoPermitidoComponent } from '@modules/acesso-nao-permitido/acesso-nao-permitido.component';

registerLocaleData(pt);

@NgModule({
  declarations: [
    AppComponent,
    MenuHeaderComponent,
    MenuAsideComponent,
    AcessoNaoPermitidoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    IconsProviderModule,
    CoreModule,
    SharedModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
